import axios from "axios";
import { getToken } from "./authUtils";
import { Message } from "element-ui";

axios.interceptors.request.use(
  config => {
    let tokenStr = getToken();
    if (tokenStr) {
      config.headers["Authorization"] = tokenStr;
    }

    return config;
  },
  error => {
    return console.log("err:", error);
  }
);

axios.interceptors.response.use(
  success => {
    if (success.data.code != 0) {
      Message.error(success.data.msg);
    }
    return success.data;
  },
  error => {
    Message.error(error);
    return;
  }
);

export default {
  GET: function(url, configs = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: "get",
        ...configs
      }).then(
        res => {
          console.log(res);
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  POST: function(url, params = {}, configs = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        data: params,
        method: "post",
        ...configs
      }).then(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/views/utils/axiosUtils.js